<template>
    <div class="space-y-2 rounded-2xl border border-gray-200 shadow-custom-xl bg-white">
        <template v-for="item in order.items" :key="item.id">
            <template v-if="item.modelType === 'product'">
                <BookingSummary :item="item" />
            </template>
            <template v-else>
                <div class="flex justify-between gap-4 px-4 mb-1">
                    <div>
                        {{ item.name }}
                        <template v-if="item.attributes?.inputType === 'quantity'">x {{ item.quantity }}</template>
                    </div>
                    <div class="text-gray-600">
                        {{ $n(item.displaySubTotal, 'currency') }}
                        <template v-if="item.attributes?.payAtLocation">*</template>
                    </div>
                </div>

                <div v-if="getRequirementRows(item).length" class="px-4 ml-2 mt-1 space-y-1">
                    <div v-for="(row, rowIndex) in getRequirementRows(item)" :key="`req-${item.id}-${rowIndex}`" class="text-xs text-gray-500">
                        {{ row }}
                    </div>
                </div>
            </template>
            <template v-if="item.attributes?.breakdown">
                <div class="px-4 space-y-1 pt-4">
                    <div class="text-[15px]">{{ $t('Accommodation') }}</div>
                    <div class="ml-2 space-y-1">
                        <template v-for="(row, index) in item.attributes.breakdown" :key="index">
                            <div class="flex justify-between gap-4 text-sm text-gray-600">
                                <span>{{ row.label }}</span>
                                <span>
                                    {{ $n(row.total, 'currency') }}
                                    <template v-if="row.payAtLocation">*</template>
                                </span>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </template>

        <template v-for="item in order.conditions" :key="item.name">
            <div class="flex justify-between gap-4 px-4 text-[15px] mt-1">
                <div>{{ item.label }}</div>
                <div>{{ $n(item.amount, 'currency') }}</div>
            </div>
        </template>

        <div class="bg-slate-100 px-4 py-3 text-slate-800 rounded-b-2xl mt-4">
            <div class="flex justify-between gap-4 text-lg font-semibold space-y-1">
                <div>{{ $t('Total') }}</div>
                <div>{{ $n(order.total, 'currency') }}</div>
            </div>
            <div class="text-xs text-gray-500">{{ $t('Items marked with * are paid at the property.') }}</div>
        </div>
    </div>
</template>

<script setup>
import { getRequirementRowsFromPayload } from '@/utils/cartRequirements'

defineProps({
    order: {
        type: Object,
        required: true
    }
})

const getRequirementRows = (item) => {
    return getRequirementRowsFromPayload(item?.attributes?.requirementsPayload)
}
</script>
